import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=2d986026"
import script from "./GroupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports